import styled from "styled-components";
import { respondTo } from "@/respondTo";


export const SelectorContainer = styled.div `
    display: flex;
    justify-content: flex-start;
    align-items: center; 
    background-color: var(--on-surface-dark);
    border-radius: 0.625rem;
    width: 100%;
    min-width: 13.1875rem;
    min-height: 10.125rem;
    position: relative;
    padding-left: 1.25rem;
    overflow-y: hidden;
    scroll-snap-align: center;
    cursor: pointer;
    

    ${respondTo.tablet_portrait`
       width: 13.625rem;
        min-height: 12.125rem;
    `}
    ${respondTo.desktop`
       width: 13.625rem;
        min-height: 12.125rem;
    `}
    ${respondTo.desktop_xl`
        width: 15.875rem;
        min-height: 12.125rem;
      
    `}

    `;

export const SelectorBox = styled.div`
display: flex;
align-items: center;
justify-content: center;
gap: 0.625rem;
padding: 0.625rem;
cursor: pointer;
    h1 {
        color: var(--on-primary-dark);
        /* width: 129px; */
    }
    img {
        width: 1.5rem;
        height: auto;
        object-fit: cover;

        ${respondTo.desktop`
            width: 2rem;
        `}

    }


    `;

export const PlusIcon = styled.div`
    position: absolute;
    right: 0.625rem;
    bottom: 0.625rem;
    cursor: pointer;
    `;

export const SelectorDescription = styled.div <{selected?: boolean }>`
//should appear from the bottom when the selector is clicked
    position: absolute;
    bottom: 0;
    left: 0;
    min-width: 13.1875rem;
    min-height: 10.125rem;
    background-color: var(--primary-container-dark);
    color: var(--on-surface-dark);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    opacity: ${({selected}) => selected ? "1" : "0"};
    visibility: ${({selected}) => selected ? "visible" : "hidden"};
    z-index: 1;
    scroll-snap-align: center;

    p {
        display: inline-block;
        text-align: flex-start;
        padding: 1.25rem 1.25rem 0;
    }

    ${respondTo.tablet_portrait`
        min-width: 13.625rem;
        min-height: 12.125rem;
    `}
    ${respondTo.desktop`
        min-width: 13.625rem;
        min-height: 12.125rem;
    `}
    ${respondTo.desktop_xl`
        min-width: 15.875rem;
        min-height: 12.125rem;
    `}
    `;